import type { FaireProductEntity } from "../../entity_types/product";

export const p_bpjeehghm7: FaireProductEntity = {
  token: "p_bpjeehghm7",
  type: "product",
  name: "FOUR THIEVES Instant Hand Sanitizer - NO RINSE",
  brandToken: "b_cvheqfzi",
  brandName: "Komoni Natural Wellness + BodyCare",
  imageUrl:
    "https://cdn.faire.com/fastly/ac62a6e3669598faa2ab9aa1bd91da7e593ac30c873ef8fa01bd924599062dee.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a56c68539eb44dcbcbba26fb4dc5d1051252a54f201c557163379613216801a7.jpeg",
    "https://cdn.faire.com/fastly/ea1fa6310a6ded16c851b1a9ccd6e18936dd43c6fd1f192310ba954aec75f4c5.jpeg",
  ],
  priceDollars: 2.95,
  description:
    "Powerful and convenient protection that nourishes your skin. Formulated with 65% ethyl alcohol to effectively kill harmful germs and bacteria, it also contains moisturizing hemp seed oil, which helps the skin retain hydration, reduce inflammation, and improve texture. The antioxidant properties of hemp seed oil support the skin’s barrier, protecting it from environmental damage while leaving your hands soft and smooth. Infused with a warm, spicy blend of cinnamon, clove, eucalyptus, rosemary, and lemon essential oils, it delivers a comforting scent as it cleans. Handcrafted in small batches with ethically sourced, vegan ingredients, it’s free from parabens, GMOs, and synthetic fragrances for a natural, skin-friendly approach to hygiene.\n\nUsage:\nSpray on hands and rub together until dry. Suitable for use on the go, at work, or after handling items in public spaces. The quick-drying, no-rinse formula leaves no sticky residue.",
  tags: [],
  msrpDollars: 5.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:32.036Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
